import {ReadyProvider} from '../../../application/providers/readyProvider';
import {Form} from '../../../application/forms/form';

ReadyProvider.executeOnReady(() => {
    let changeEmailBlock = document.querySelector('[data-form="change-email"]');
    let notConfirmedBlock = document.querySelector('[data-block="not-confirmed"]');

    if (changeEmailBlock && notConfirmedBlock) {
        let resendFormElement = document.querySelector('[data-form="resend"]'),
            resendForm = new Form(resendFormElement),
            changeEmailForm = new Form(changeEmailBlock);

        resendForm.setSuccessCallback(() => {
            resendFormElement.querySelector('[data-action="resend"]').classList.add('hidden');
        });

        changeEmailForm.setSuccessCallback(() => {
            changeEmailBlock.classList.add('hidden');
            notConfirmedBlock.classList.remove('hidden');

            let email = changeEmailBlock.querySelector('[name="email"]').value;
            Array.from(notConfirmedBlock.querySelectorAll('[data-email="resend"]')).forEach((element) => element.innerHTML = email);

            resendFormElement.querySelector('[data-form="message"]').innerHTML = '';
            resendFormElement.querySelector('[data-action="resend"]').classList.remove('hidden');
        });

        document.querySelector('[data-email="change"]').addEventListener('click', () => {
            changeEmailBlock.classList.remove('hidden');
            notConfirmedBlock.classList.add('hidden');
        });
    }
});
